import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import firebase from 'firebase';
import { LoaderPlugin } from 'vue-google-login';

import App from './App.vue';
import router from './router';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

const config = {
  apiKey: 'AIzaSyCRKT9jN-olf8gQte1hP-LHgG0D80dIAqo',
  authDomain: 'website-calendar-ed9b9.firebaseapp.com',
  databaseURL: 'https://website-calendar-ed9b9.firebaseio.com',
  projectId: 'website-calendar-ed9b9',
  storageBucket: 'website-calendar-ed9b9.appspot.com',
  messagingSenderId: '119500012444',
};

firebase.initializeApp(config);

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(require('vue-moment'));

Vue.use(LoaderPlugin, {
  client_id: '119500012444-8ft7vemlrobdue1t2p765h95hggnuh5l.apps.googleusercontent.com',
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Calendar';
      },
    },
  },
}).$mount('#app');
